import { render, staticRenderFns } from "./ModalEditUserRole.vue?vue&type=template&id=c358e742&scoped=true"
import script from "./ModalEditUserRole.vue?vue&type=script&lang=js"
export * from "./ModalEditUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c358e742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c358e742')) {
      api.createRecord('c358e742', component.options)
    } else {
      api.reload('c358e742', component.options)
    }
    module.hot.accept("./ModalEditUserRole.vue?vue&type=template&id=c358e742&scoped=true", function () {
      api.rerender('c358e742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalEditUserRole.vue"
export default component.exports